import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Row, Col, Button } from 'react-bootstrap';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import ReactCodeInput from "react-code-input";
import {  
    handleChangeLoaderPageReferal, 
    handleChangeDisabledBtnPageReferal, 
    handleChangeBtnClassPageReferal, 
    handleChangeInputReferalPage } from "../../../../redux/actions/pages/user/referal";
import { handleChangeProfileData, handleChangeToken } from "../../../../redux/actions/pages/user/user";
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, USERS_CHECK_REFERAL_POST } from '../../../../apis'; 
import Swal from 'sweetalert2';
import axios from "axios";
import * as qs from "querystring";


const Referal = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const { token, profile } = useSelector(state => state.user);
    const { code, disabledBtn, isLoading, btnClass, temporaryToken} = useSelector(state => state.referal);



    const handleBackBtn = () => {
        dispatch(handleChangeInputReferalPage('showReferalPage', false));
        dispatch(handleChangeInputReferalPage('temporaryToken', false));
        // navigate(`../login`);
        navigate(`/`);
    };


    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });




    const handleChangeInputCodeReferalPage = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "code", value: event} : event.target;
        dispatch(handleChangeInputReferalPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    useEffect(() => {
        handleActivationBtn();
    }, [code]);

    const handleActivationBtn = () => {
        if (code.length === 6 && !isLoading) {
            dispatch(handleChangeBtnClassPageReferal());
            // toast.warning('در حال بررسی کد فعال سازی', {
            //     position: toast.POSITION.BOTTOM_CENTER
            // });
            apiActivation();
        }
        else
            dispatch(handleChangeBtnClassPageReferal('disable-btn'));
    };

    const handleSkipStep = () => {
        dispatch(handleChangeInputReferalPage('showReferalPage', false));
        dispatch(handleChangeInputReferalPage('temporaryToken', false));
        navigate(`/edit_profile`, { replace: true });
    };

    const apiActivation = () => {
        if (code.length === 6 && !isLoading)
        {
            dispatch(handleSetBackdropLoading(true));
            dispatch(handleChangeLoaderPageReferal(true));
            dispatch(handleChangeBtnClassPageReferal('disable-btn'));


            var postData = {code: code};
            axios({
                method: 'post',
                url: BASE_SITE + USERS_CHECK_REFERAL_POST,
                data: qs.stringify(postData), 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': temporaryToken
                },
            }).then((response) => {
                switch (response.data.status) {
                    case 'error':
                        btnOkSingle.fire({
                            title: "خطا ",
                            text: response.data.message,
                            imageUrl: SitagLogo,
                            imageHeight: 80,
                            imageAlt: 'سیتگ',
                            confirmButtonText: "تایید",
                        });
                        break;
                    case 'ok':
                        dispatch(handleChangeProfileData(response.data.info));
                        dispatch(handleChangeToken(response.data.token));


                        dispatch(handleChangeInputReferalPage('code', ''));
                        dispatch(handleChangeInputReferalPage('disabledBtn', true));
                        dispatch(handleChangeInputReferalPage('isLoading', false));
                        dispatch(handleChangeInputReferalPage('btnClass', 'disable-btn'));
                        dispatch(handleChangeInputReferalPage('showReferalPage', false));
                        dispatch(handleChangeInputReferalPage('temporaryToken', false));

                        break;
                    default:
                        btnOkSingle.fire({
                            title: "خطا ",
                            text: "لطفا مجددا تلاش کنید.",
                            imageUrl: SitagLogo,
                            imageHeight: 80,
                            imageAlt: 'سیتگ',
                            confirmButtonText: "تایید",
                        });
                        // handelChangeInputCodeModalLogin('');
                }
                dispatch(handleSetBackdropLoading(false));
                dispatch(handleChangeLoaderPageReferal(false));
                dispatch(handleChangeBtnClassPageReferal(''));
            }, () => {
                btnOkSingle.fire({
                    title: "خطا ",
                    text: "لطفا مجددا تلاش کنید.",
                    imageUrl: SitagLogo,
                    imageHeight: 80,
                    imageAlt: 'سیتگ',
                    confirmButtonText: "تایید",
                });
                dispatch(handleSetBackdropLoading(false));
                dispatch(handleChangeLoaderPageReferal(false));
                dispatch(handleChangeBtnClassPageReferal(''));
            });
        }
    };


    const propsCode = {
        className: '',
        inputStyle: {
            margin: 'calc(2px + (8 - 2) * ((100vw - 320px) / (1920 - 320)))',
            backgroundColor: '#f6f5fa',
            fontSize: '14px',
            padding: 'calc(8px + (14 - 8) * ((100vw - 320px) / (1920 - 320))) calc(12px + (15 - 12) * ((100vw - 320px) / (1920 - 320)))',
            borderRadius: '0.25rem',
            textAlign: 'center',
            overflow: 'visible',
            width: '52px',
            class: 'custom-vertical-padding',
        },
        inputStyleInvalid: {
            margin: 'calc(2px + (8 - 2) * ((100vw - 320px) / (1920 - 320)))',
            backgroundColor: '#fff',
            fontSize: '14px',
            padding: 'calc(8px + (14 - 8) * ((100vw - 320px) / (1920 - 320))) calc(12px + (15 - 12) * ((100vw - 320px) / (1920 - 320)))',
            borderRadius: '0.25rem',
            textAlign: 'center',
            overflow: 'visible',
            width: '52px',
        }
    }

    return (

        <div id="verification-page">
            <Row className="pt-5">
                <Col xs={1} className="d-flex align-items-center">{/*<img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" />*/}</Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        به 
                        <Link to=".."><img src={SitagLogo} className="logo-in-txt mx-2" alt="سیتگ" /></Link>
                        خوش آمدید
                    </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={12} className="text-center mt-3">
                    در صورت داشتن کد معرف آن را وارد کنید
                </Col>
            </Row>

            <Row className="mt-4">
                <Col className="text-center mt-4">
                    <ReactCodeInput 
                        type='text' 
                        inputMode="text" 
                        fields={6} 
                        name={'code'} 
                        id="input-code" 
                        value={code} 
                        autocomplete={'one-time-code'}
                        style={{direction: 'ltr'}}
                        pattern="[0-9]*"
                        placeholder="-"
                        autoFocus={false}
                        onChange={handleChangeInputCodeReferalPage}
                        {...propsCode} />
                </Col>
            </Row>


            <Row className="mt-1">
                <Col xs={12} className="text-center mt-4">
                    <Button className={`w-100 custom-vertical-padding login-form-button ${btnClass}`} onClick={handleActivationBtn} >
                        ثبت
                    </Button>
                </Col>

                {/*<Col xs={12} className="text-center mt-4">
                    <input type="button" className={`w-100 custom-vertical-padding primary-border primary-txt-color radius-10`} onClick={handleBackBtn} value="انصراف" />
                        
                </Col>*/}

                <Col xs={12} className="text-center mt-4">
                    <Button className={`w-100 custom-vertical-padding login-form-button`} onClick={handleSkipStep} >
                        مرحله بعد
                    </Button>
                </Col>
            </Row>

        </div>

    );
}

export default Referal;